export const Footer = () => (
  <footer className="shrink-0 relative">
    <div
      className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-blue-600/50 to-transparent dark:via-blue-400/40"
      aria-hidden
    />
    <div className="border-t border-gray-200/80 dark:border-gray-800 bg-gradient-to-b from-white to-gray-50/95 dark:from-gray-900 dark:to-gray-950 px-6 py-4">
      <p className="text-center text-xs sm:text-sm text-gray-500 dark:text-gray-400 leading-relaxed">
        © 2026{" "}
        <span className="font-semibold text-gray-800 dark:text-gray-100">
          Hibbert Group
        </span>
        . All rights reserved.
      </p>
    </div>
  </footer>
);
